export const FORMATTER_LOCALE = 'pt-BR';
export const FORMATTER_CURRENCY = 'BRL';

export const DEFAULT_CURRENCY_DECIMALS = 2;
export const DEFAULT_PERCENT_DECIMALS = 1;
export const DEFAULT_NUMBER_DECIMALS = 0;

/** Display para valores null/undefined/NaN. */
export const NULL_DISPLAY = '—';
